(function () {
  'use strict';

  angular
      .module('tfc.Files')
      .controller('UploadFormCtrl', UploadFormCtrl)
      .directive('tfcUploadForm', tfcUploadForm);

  // @ngInject
  function UploadFormCtrl($rootScope,
                          $scope,
                          Retailer,
                          Toast,
                          ReportCategories,
                          ProgressModal,
                          Reports,
                          ReportUtil,
                          Upload,
                          $stateParams,
                          $state,
                          ApiErrorHandler) {
    var vm = this;


    vm.report = { isActive : true, sendEmail : true };
    vm.contentUrl = null;
    vm.categories = ReportCategories;
    vm.isPreviewable = ReportUtil.isPreviewable;
    vm.validContentTypes = function () {
      return ReportUtil.validContentTypes().join(',');
    };
    vm.params = _.cloneDeep($stateParams);

    if (vm.params.tla) {
      vm.report.tla = vm.params.tla;
      if (vm.params.category) {
        vm.report.category = vm.params.category;
      }
    }

    vm.onChange = function (invalidFiles) {
      if (invalidFiles.length) {
        Toast.warn('files.publish.invalid');
      }
      var file = vm.report.file;
      // So isPreviewable works.
      vm.report.contentType = file && file.type;
      if (file) {
        // There's a race condition when using ngf-src="vm.report.file".
        // If the <embed> tag is made visible before Upload creates the dataUrl,
        // it doesn't appear on some computers. Doing it this way fixes that.
        Upload.dataUrl(file).then(function (url) {
          vm.contentUrl = url;
        });
      } else {
        vm.contentUrl = null;
      }
    };

    $scope.$on('dragndropfile', function (event, file) {
      if (!_.includes(vm.validContentTypes(), file.type)) {
        $state.go('files', vm.params);
        Toast.warn('files.publish.invalid');
      } else {
        vm.report.file = file;
        console.log(file);
        vm.report.name = file.name;
        vm.onChange([]);//pass an empty array because I already checked for invalid files
      }
    });
    $rootScope.$broadcast('uploadFormLoaded');

    Retailer.find().then(function (stores) {
      // filter out the stores that are defunct
      vm.stores = stores.filter(function(store) {
        return ['L','SL','M','O'].includes(store.status)
      });
    });

    vm.onCategoryChange = function () {
      updateDatepickerOptions();
      vm.report = _.pick(vm.report, [
        'fileKey',
        'tla',
        'category',
        'file',
        'isActive'
      ]);
    };

    function updateDatepickerOptions() {
      vm.datepickerOptions = {
        week : {
          label : 'files.publish.date',
          format : 'yyyy-MM-dd',
          minMode : 'day'
        },
        month : {
          label : 'files.publish.month',
          format : 'yyyy-MM',
          minMode : 'month'
        },
        quarter : {
          label : 'files.publish.year',
          format : 'yyyy',
          minMode : 'year'
        }
      }[vm.report.category];
    }

    vm.showDatepicker = function (category) {
      return category &&  category !== 'other';
    };

    vm.updateSendEmail = function () {
      vm.report.sendEmail = vm.report.isActive;
    };

    vm.submit = function () {
      var promise = Reports.upload(vm.report);
      ProgressModal.showModal(promise, {
        translationKey : 'files.publish.uploading'
      }).then(function () {
        Toast.success('files.publish.success');
        vm.onUpload();
      }, function (response) {
        if (response.status === 409) {
          Toast.error('files.publish.duplicate', { state : true });
        } else {
          ApiErrorHandler.toastError(response);
        }
      });
    };

    vm.getStoreName = function (tla) {
      return _.get(_.find(vm.stores, { tla : tla }), 'name');
    };
  }

  // @ngInject
  function tfcUploadForm() {
    return {
      bindToController : true,
      controller : 'UploadFormCtrl as vm',
      templateUrl : 'Files/UploadForm.tmpl.html',
      scope : {
        onUpload : '&'
      }
    };
  }

})();
